import { useEffect, useRef, useState } from "react";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
import ConfirmModal from "../../components/ConfirmModal";
import API_URL from "../../api/API";
import LocationForm from "./LocationForm";

const LocationActionsDropdown = ({ location, refresh }) => {

  
  const ref = useRef();
  const [open, setOpen] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const { business } = useBusinessAuthContext();
  const [showConfirm, setShowConfirm] = useState(false);

  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const makeLocationInactive = async () => {

    try {
      
      if (saving) return;
      setSaving(true);

      const res = await fetch(
        `${API_URL.BUSINESS_LOCATION_MAKE_INACTIVE}/${location._id}`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${business.token}`,
            "x-session-id": business.sessionId,
            "x-frontend-url": window.location.pathname,
          },
        }
      );

      const data = await res.json();

      if (!data.success) {
        alert(data.message || "Unable to update location");
        return;
      }

      setShowConfirm(false);
      refresh();
      setOpen(false);
    } catch (err) {
      console.error(err);
      alert("Unable to update location");
    } finally {
      setSaving(false);
    }
  };

  const makeLocationActive = async () => {
    try {

      if (saving) return;
      setSaving(true);

      const res = await fetch(
        `${API_URL.BUSINESS_LOCATION_MAKE_ACTIVE}/${location._id}`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${business.token}`,
            "x-session-id": business.sessionId,
            "x-frontend-url": window.location.pathname,
          },
        }
      );

      const data = await res.json();

      if (!data.success) {
        alert(data.message || "Unable to update location");
        return;
      }

      refresh();
      setOpen(false);
    } catch (err) {
      console.error(err);
      alert("Unable to update location");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div className="relative" ref={ref}>
        <button onClick={() => setOpen(!open)}>⋮</button>

        {open && (
          <div className="absolute right-0 mt-2 w-44 bg-white shadow-lg rounded-lg border z-50">
            <button
              onClick={() => {
                setShowEdit(true);
                setOpen(false);
              }}
              className="block w-full text-left px-4 py-2 hover:bg-gray-50"
            >
              Edit Location
            </button>

            <button
            
              disabled={saving}

              onClick={() => {
                if (location.isActive) {
                  setShowConfirm(true);
                } else {
                  makeLocationActive();
                }

                setOpen(false);
              }}
              className="block w-full text-left px-4 py-2 hover:bg-gray-50"
            >
              {location.isActive ? "Mark Inactive" : "Make Active"}
            </button>

            {/* <button className="block w-full text-left px-4 py-2 hover:bg-gray-50 text-red-500">
              Delete
            </button> */}
          </div>
        )}
      </div>

      {/* ✅ Edit Modal */}
      {showEdit && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-md relative">
            <button
              onClick={() => setShowEdit(false)}
              className="absolute top-3 right-3 text-gray-500"
            >
              ✕
            </button>

            <h2 className="text-lg font-semibold mb-4">Edit Location</h2>

            <LocationForm
              existingLocation={location}
              onSuccess={() => {
                setShowEdit(false);
                refresh();
              }}
            />
          </div>
        </div>
      )}

      <ConfirmModal
        open={showConfirm}
        title="Mark Location Inactive"
        message="This location may be assigned to active waivers. Making it inactive will stop new signatures for the selected location(s), but all signed records will remain unchanged."
        confirmText="Mark Inactive"
        cancelText="Cancel"
        onConfirm={makeLocationInactive}
        onCancel={() => setShowConfirm(false)}
      />
    </>
  );
};

export default LocationActionsDropdown;